export default {
  REQUEST_RECEIVED: 'AUTH/OTP/REQUEST_RECEIVED',
  COMPLETED: 'AUTH/OTP/COMPLETED'
}
